export default {
  title: 'Announcements',
  subtitle: 'Communicate with your tenants',
  new_button: 'New Announcement',
  form: {
    title_label: 'Title',
    title_placeholder: 'e.g. Water outage on 15 March',
    title_counter: '{{count}} remaining',
    body_label: 'Body',
    body_hint: 'Plain text only.',
    publish_label: 'Publish Date & Time',
    expires_label: 'Expiry Date & Time',
    expires_hint: 'Optional. Leave blank for no expiry.',
    target_label: 'Target',
    target_all: 'All Tenants',
    target_property: 'Specific Property',
    target_unit: 'Specific Unit',
    property_label: 'Property',
    unit_label: 'Unit',
    save_button: 'Save Announcement',
    create_success: 'Announcement created.',
    update_success: 'Announcement updated.',
    delete_confirm: 'Delete this announcement? This cannot be undone.',
    delete_success: 'Announcement deleted.',
  },
  status: { active: 'Active', scheduled: 'Scheduled', expired: 'Expired' },
  target: { all: 'All Tenants', property: 'Property', unit: 'Unit' },
  detail: { published: 'Published', expires: 'Expires', no_expiry: 'No expiry', created_by: 'Created by' },
  empty: { title: 'No announcements yet', description: 'Create an announcement to communicate with tenants.' },
}
